import { Injectable, inject } from '@angular/core';
import { WorkflowStepType } from '@warema/shared/models';
import { WorkflowValidationService } from '@warema/shared/workflows/workflow-common/data-access';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class WorkflowValidationApiService {
    private readonly _workflowValidationService = inject(WorkflowValidationService);

    public manageWorkflowValidation(isFormValid$: Observable<boolean>, stepType: WorkflowStepType): void {
        this._workflowValidationService.manageWorkflowValidation(isFormValid$, stepType);
    }
}
